module.exports = __webpack_public_path__ + "img/bookmark.efbcbe31.svg";